import React from 'react';
import { viewerTimeZone } from '../helpers/time.helper';
import './TimeZoneNote.scss';

/*
  Says which zone the times of a table are shown in, once for the table: the viewer's own (FriendlyDate), whatever the zone of the
  backend, which writes them in UTC. Goes inside the table's card, before the table (or under a list of details).
*/
export const TimeZoneNote = () => {
    const zone = viewerTimeZone();

    return (
        <div className={'time-zone-note'}>
            {zone
                ? `Times shown in your time zone (${zone})`
                : 'Times shown in your time zone'}
        </div>
    );
};
